import { Link } from "react-router-dom";
import FaqAccordion from "@/components/base/FaqAccordion";
import SectionHeading from "@/components/base/SectionHeading";
import { faqList } from "@/mocks/faq";

export default function FaqPreview() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="max-w-shell mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              eyebrow="常见问题"
              title="你想问的，大概都在这"
              description="关于评分怎么算、弱证据怎么处理、隐私边界划在哪里，我们一次说清楚。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
            >
              查看全部问答
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="lg:col-span-8">
            <FaqAccordion items={faqList.slice(0, 5)} />
          </div>
        </div>
      </div>
    </section>
  );
}